import React, { useState } from "react";
import { Link, Redirect, useNavigate } from "react-router-dom";
import { lines, login02, logo , logoCuidado} from "../../imagepath";
import { cambiarPin } from "../../../services/user";
import { ScaleLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const OlvidePin = () => {
  const [enviado, setEnviado] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [pin, setPin] = useState("");
  const [confirmacion, setConfirmacion] = useState("");
  const [loading, setLoading] = useState(false);
  const [pinVisible, setPinVisible] = useState(false);

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage(null);
    if (!pin || !confirmacion) {
      console.log(pin);
      console.log(confirmacion);
      setEnviado(false);
      setErrorMessage("Por favor, complete los campos");
      setLoading(false);
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    try {
      const data = { pin: pin, confirmacionPin: confirmacion, token: token };
      var respuesta = await cambiarPin(data);
      if (respuesta.ok === true) {
        setEnviado(true);
        setLoading(true);
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setErrorMessage(respuesta.mensaje);
      }
    } catch (error) {
      console.error("Error cancelando subscripcion :", error);
      setErrorMessage("Ha ocurrido un error, favor intentar mas tarde.");
      setLoading(false);
    }
  };

  const togglePinVisibility = () => {
    setPinVisible(!pinVisible);
  };

  return (
    <div>
      {loading && (
        <div className="overlay-loading">
          <ScaleLoader
            css={override}
            size={150}
            color={"#4e57cd"}
            loading={loading}
          />
        </div>
      )}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <div className="login-sec"></div>
            <div className="col-lg-6">
              <div className="log-img"></div>
            </div>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="logoHumano">
                        <Link to="/admin">
                          <img src={logo} alt="#" width={200} />
                        </Link>
                      </div>
                      <div className="logoCuidado">
                        <Link to="/login">
                          <img src={logoCuidado} alt="#" width={160} />
                        </Link>
                      </div>
                      <div className="titles">
                        <label className="title">Cambio de pin</label>
                        <label className="label-description  mb-5">
                          Favor ingresar su correo electrónico{" "}
                        </label>
                      </div>
                      {errorMessage && (
                        <div className="text-center text-danger mb-3">
                          {errorMessage}
                        </div>
                      )}
                      {/* Form */}
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label>
                            PIN <span className="login-danger">*</span>
                          </label>
                          <input
                            type={pinVisible ? "text" : "password"}
                            className="form-control pass-input flex-grow-1"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={pin}
                            onChange={(e) => setPin(e.target.value)}
                          />
                          <span
                            className="toggle-password ml-2"
                            onClick={togglePinVisibility}
                          >
                            {pinVisible ? (
                              <EyeOff className="react-feather-custom" />
                            ) : (
                              <Eye className="react-feather-custom" />
                            )}
                          </span>
                        </div>
                        <div className="form-group">
                          <label>
                            Confirmar PIN{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            type={pinVisible ? "text" : "password"}
                            className="form-control pass-input flex-grow-1"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={confirmacion}
                            onChange={(e) => setConfirmacion(e.target.value)}
                          />
                          <span
                            className="toggle-password ml-2"
                            onClick={togglePinVisibility}
                          >
                            {pinVisible ? (
                              <EyeOff className="react-feather-custom" />
                            ) : (
                              <Eye className="react-feather-custom" />
                            )}
                          </span>
                        </div>
                        <div className="form-group login-btn">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Enviar
                          </button>
                        </div>
                      </form>
                      {/* /Form */}
                      {/* Mensaje de correo enviado */}
                      {enviado && (
                        <div className="alert alert-success" role="alert">
                          PIN Restablecido exitosamente, redireccionando a
                          iniciar sesion..
                        </div>
                      )}
                    </div>
                  </div>
                  <img className="login-lines" src={lines} />
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OlvidePin;
